<script lang="ts">
  import ActionRequiredBanner from "@retailer/svelte/Shared/ActionRequiredBanner.svelte";
  import RetailerDistributorStore from "@retailer/svelte/stores/RetailerDistributorStore";
  import {
    statusRed,
    statusGreen,
    statusGray,
    statusBarDisplayState,
  } from "@shared/services/order_status_service";

  import type { SharedOrder } from "@shared/types/Order";
  import type { RetailerType } from "@shared/types/Retailer";
  export let retailer: RetailerType;
  export let order: SharedOrder;

  $: retailerDistributor = $RetailerDistributorStore.find(
    rd => rd.distributor.id === order.distributor.id,
  );
  $: actionRequired = order.manual_order_action_required && retailerDistributor?.is_aoo_enabled;
  $: orderDisplayState = statusBarDisplayState(order);
</script>

<style lang="scss">
  .break-word {
    word-break: break-word;
  }
</style>

<div class="margin-bottom--small">
  {#if actionRequired}
    <ActionRequiredBanner {order} {retailer} on:orderUpdated />
  {:else}
    <div
      id="order-status-bar"
      data-testid="order-status-bar"
      class:background-red={statusRed(orderDisplayState)}
      class:background-green={statusGreen(order, orderDisplayState)}
      class:background-grayDark={statusGray(order, orderDisplayState)}
    >
      <div class="grid-container padding-top--smaller padding-bottom--smaller">
        <div class="grid-row padding-left--smaller--sm padding-right--smaller--sm">
          <div class="grid-col c6-12 c4-12--md">
            <span class="capitalize light-small--bold light-body--bold--sm">
              {orderDisplayState}
            </span>
          </div>
          {#if order.rep_notes}
            <div class="grid-col break-word">
              <span class="light-body--regular">
                <p data-testid="order-rep-notes">"{order.rep_notes}"</p>
              </span>
            </div>
          {/if}
        </div>
        {#if statusRed(orderDisplayState) && order.distributor_notes}
          <div class="grid-row padding-left--smaller--sm padding-right--smaller">
            <div class="grid-col c12-12 margin-top--smallest">
              <span class="light-serif--regular">"{order.distributor_notes}"</span>
            </div>
          </div>
        {/if}
      </div>
    </div>
  {/if}
</div>
